import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>Terms and Conditions - MI Junior Cricket Registration</title>
        <meta name="description" content="Terms and conditions for MI Junior Cricket Tournament registration." />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto px-4 py-8 lg:py-12 max-w-4xl">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center gap-4 mb-6">
              <Button
                variant="ghost"
                size="default"
                iconName="ArrowLeft"
                iconPosition="left"
                onClick={handleGoBack}
              >
                Back
              </Button>
            </div>
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
              Terms and Conditions
            </h1>
            <p className="text-lg text-gray-600">
              MI Junior Cricket Tournament 2026
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-6 lg:p-10">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 mb-6">
                These Terms and Conditions are applicable to each School participating in the MI Juniors inter-school cricket tournament in the U14 Boys, U15 Girls and U16 Boys categories ("Category/ies") to be held in Mumbai and Nagpur between February 2026 and March 2026 (the "Tournament") being organised by Indiawin Sports Private Limited (the "Organizer"). The Tournament has been approved by Mumbai Cricket Association in Mumbai and Vidharbha Cricket Association in Nagpur.
              </p>

              <p className="text-gray-700 mb-8 font-semibold">
                By submitting this form, the School agrees that it shall, and shall procure that its students playing in the Tournament (the "Player/s") shall, be bound by and comply with the terms and conditions set out below:
              </p>

              <ol className="space-y-6 text-gray-700">
                <li className="pl-4">
                  <p className="mb-2">
                    The School hereby agrees and confirms that its Players will be bound by and comply with all guidelines including the eligibility criteria and other rules and regulations of the Tournament as notified by the Organizer from time to time and by submitting this registration form, it and its Players shall be deemed to have read and understood the terms and conditions as set out herein.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School confirms that, the age of each Player conforms with the eligible age criteria for each Category and that Date of Birth of each Player has been verified against official and authentic documents. The Tournament organizers ("Organizers") shall in good faith rely entirely on the above confirmation by the School and will not be liable for any discrepancies, protests or claims related to age discrepancies which shall be the sole responsibility of the School. If any discrepancies are discovered during or after the Tournament, the Organizers reserve the right to take appropriate action include disqualification of the relevant Player or School Team.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School acknowledges that all the personal information of the Players as submitted by the School is true and correct, and if any of the information provided herein becomes untrue or incorrect the School undertakes to immediately inform the Organizer of such change. In the event that the Organizers find that any information as submitted by a School whether in respect of its Players or otherwise, is found to be incorrect/untrue, then such School shall be liable to be disqualified immediately from participating in the Tournament at the Organizers' sole discretion.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School confirms that its Players are fit to participate in the Tournament and that they do not suffer from any physical or mental disabilities which may or may be likely to, endanger his or her health in any manner whatsoever as a result of participation in the Tournament.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School confirms that it is participating in the Tournament without any monetary compensation whatsoever from the Organizers and entirely on a voluntary basis at its own risk, cost and expense. The School agrees and shall procure that the Players and their respective guardians hereby irrevocably agree that they will not hold or seek to hold the Organizers or any of its affiliates or group companies, responsible or liable for any injuries, harm, damage, psychological trauma, losses or damages of any kind whatsoever suffered or incurred by or caused to the Players at or during the Tournament.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School acknowledges that the conduct of the Tournament is subject to factors beyond the reasonable control of the Organizers including Force Majeure conditions, and in the event of cancellation, rescheduling or change of venue of the Tournament on account of any such factors, the School shall not be entitled to reimbursement of any costs or charges whatsoever and shall not make any claims whatsoever against the Organisers in relation to such cancellation, rescheduling or change of venue.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    In case of illness or injury occurring to a Player participating in the Tournament basic/emergency medical treatment shall be administered by the Tournament medical support team at the Organizers' cost. The Organizers shall have no further liability in respect of any such illness/injury/death occurred to a Player whilst participating in the Tournament and neither the School nor the Player will have any further claim against the Organizer. The School, the Player and his or her parent/guardian will not hold or seek to hold the Organizer, or any of its affiliates or group companies responsible or liable for any injuries suffered or caused by the Player at or during the Tournament. The Organizers will not be responsible or liable if the School fields or allows Players who are unwell to participate in the Tournament. The School agrees to adhere to protocols set by the Organizer in case of any event of a medical emergency or pandemic.
                  </p>
                  <p className="mb-2 mt-4">
                    The Organizers shall have the right to the use of the Player's photographs, footage and or/image and in any media whatsoever, and the School acknowledges on the behalf of itself, the Player and the Player's parent/guardian that all rights, title and interest, including without limitation, intellectual property rights in such photographs/images/footage vest in the Organizer at all times. In this regard, by virtue of acknowledging to have read and agreed to this registration form and by submitting this registration form, the School hereby grants an express right (which it shall have been deemed to have procured from its Players as well) in favour of the Organizer, with a right for the Organiser to sub-license such rights including to its official partners, in perpetuity.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    No Player shall be permitted to represent more than one School or play in more than one category during the same season of the Tournament.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School confirms that the Player is a bonafide full-time student of the School for the Academic Year in the class as mentioned in the Student Details section of the Registration form and the above Information has been verified with the admission records and found to be correct.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    In the event that the information furnished above is found to be partly or wholly untrue, the Player and the School are liable to be disqualified, at the Organizer's sole discretion, from participation in this edition of the Tournament as well as future editions of the same.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School shall procure all requisite consents/declarations/undertaking and/or any other compliance specified under the Regulations (and its amendments if any), as required to be obtained from their respective students (and from legal guardians in case of minors) in order to enable the use of student information by the Organizers, for promotion of the Tournament.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    Schools shall ensure that arrangements are made for their respective teams to be punctually present at every match venue and ensure safety of Players during their travel to and back from the venue. As a mandatory protocol, School teams should be accompanied with coach/PE teacher or School authorised personnel.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    In case of being a Mumbai based School, the School shall follow age verification protocol put in place by Mumbai Cricket Association. If the School Team proceeds further in the later stages of the Tournament, cost for age verification test will be borne by the School and the School Team Players will be present for the same as advised by the Organizers and the Mumbai Cricket Association.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    The School once registered, agrees to participate in all its matches. Absence of the School team for any match after a schedule is drawn (walk-overs) will impact participation of the School in future seasons of the Tournament. Schools agree to not pressurise the Organiser to re-schedule their matches. Schools agree to make their teams/players available for all the matches during the course of the Tournament.
                  </p>
                </li>

                <li className="pl-4">
                  <p className="mb-2">
                    Any decision taken by the Tournament management and/or the Tournament Committee will be final and binding. Further the School hereby expressly agrees and acknowledges that it shall at all times inculcate the values of sportsmanship and fair play in its Players and that the School and its Players will at all times during the Tournament (i) uphold the laws of the game of Cricket, (ii) be respectful and courteous with the Tournament staff and its opponents, (iii) it shall not indulge in any kind of misconduct/misdemeanours, (iv) its Players shall be respectful towards the Umpires and any decisions rendered by the Umpires shall be final and binding on the Players; (v) comply with all decisions taken by the Organizers and/or Tournament Committee, as the case may be, with respect to the conduct of the Tournament.
                  </p>
                </li>
              </ol>
            </div>

            {/* Footer Actions */}
            <div className="mt-8 pt-6 border-t border-gray-200 flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="outline"
                size="default"
                iconName="ArrowLeft"
                iconPosition="left"
                onClick={handleGoBack}
              >
                Go Back
              </Button>
              <Button
                variant="default"
                size="default"
                iconName="Home"
                iconPosition="left"
                onClick={handleGoHome}
              >
                Back to Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;

